<template>
  <section class="section plants-report" id="zglos-blad" aria-labelledby="report-heading">
    <h2 class="section__title" id="report-heading">{{ $t('report_section_title') }}</h2>
    <p class="plants-report__intro">{{ $t('report_section_lead') }}</p>
    <ul class="plants-report__list">
      <li>{{ $t('report_reason_toxicity') }}</li>
      <li>{{ $t('report_reason_missing') }}</li>
      <li>{{ $t('report_reason_photo') }}</li>
      <li>{{ $t('report_reason_source') }}</li>
    </ul>
    <p class="plants-report__action">
      <button
        type="button"
        class="chip chip--primary"
        v-b-modal.plant-modal
        @click="openGeneralReport"
      >
        {{ $t('report_open_form') }}
      </button>
      <a class="plants-report__mailto" href="mailto:kontakt@plants4pets.pl">{{ $t('write_email') }}</a>
    </p>
    <p class="plants-report__note">{{ $t('report_section_note') }}</p>
  </section>
</template>

<script>
import { usePlantStore } from '@/stores/plant-store'

export default {
  methods: {
    openGeneralReport () {
      usePlantStore().selected_plant = null
    }
  }
}
</script>
